export default "assets/images/icons/fleche-prev-5c6a2dca.svg";